import { Injectable } from '@angular/core';
import { map, switchMap, mergeMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as paymentTableColumnActions from '@payments-to-you/actions/payments-to-you-table-columns';
import * as paymentTableActions from '@payments-to-you/actions/payments-to-you-table';

import { IColumnDefinition } from '../../common/models/column-definition';
import { PaymentsToYouHttpService } from '@payments-to-you/services/payments-to-you-http.service';

@Injectable()
export class PaymentsTableColumnsEffects {

  constructor(
    private readonly actions$: Actions,
      private readonly paymentsToYouHttpService: PaymentsToYouHttpService
  ) { }


  loadColumnsEffect = createEffect(() => this.actions$.pipe(
      ofType(paymentTableColumnActions.load),
      mergeMap(({ widget }) => {
          return this.paymentsToYouHttpService.getPaymentsTableColumns(widget.id).pipe(
              map((columns: IColumnDefinition[]) => paymentTableColumnActions.loadComplete({payload: columns, widget}))
          );
      })
  ));

  loadAllColumnsEffect = createEffect(() => this.actions$.pipe(
      ofType(paymentTableColumnActions.loadAll),
    switchMap(() => {
      return this.paymentsToYouHttpService.getAllPaymentsTableColumns().pipe(
        map((columns: IColumnDefinition[]) =>  paymentTableColumnActions.loadAllComplete({ payload: columns }))
      );
    })
  ));

  updateMojoColumnsEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.updateMojoColumn),
      switchMap(({context, columnDefinition, widget}) => {
      return this.paymentsToYouHttpService.putPaymentsTableColumns(columnDefinition, widget.id).pipe(
        map(() => paymentTableColumnActions.updateMojoColumnComplete({ context, widget }))
      );
    })
  ));

  updateMojoColumnsCompleteEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.updateMojoColumnComplete),
    map(({ context, widget }) => {
      return paymentTableActions.loadInternal({ context, widget });
    })
  ));

  loadMojoDefaultsEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.resetToMojoDefault),
    switchMap(({ context, widget }) => {
        return this.paymentsToYouHttpService.setTableDefaultColumns(widget.id).pipe(
        map(() => paymentTableColumnActions.updateMojoColumnComplete({ context, widget }))
      );
    })
  ));

  updateMfsColumnsEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.updateMfsColumn),
    switchMap(({ accountRef, columnDefinition, widget }) => {
      return this.paymentsToYouHttpService.putPaymentsTableColumns(columnDefinition, widget.id).pipe(
          map(() => paymentTableColumnActions.updateMfsColumnComplete({ accountRef, widget }))
      );
    })
  ));

  updateMfsColumnsCompleteEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.updateMfsColumnComplete),
      map(({ accountRef, widget }) => {
          return paymentTableActions.loadExternal({ accountRef, widget });
    })
  ));

  loadMfsDefaultsEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.resetToMfsDefault),
      switchMap(({ accountRef, widget }) => {
      return this.paymentsToYouHttpService.setTableDefaultColumns(widget.id).pipe(
          map(() => paymentTableColumnActions.updateMfsColumnComplete({ accountRef, widget }))
      );
    })
  ));

  reorderColumnsEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.reorderColumns),
    switchMap(({ payload, widget }) => {
      return this.paymentsToYouHttpService.reorderPaymentsTableColumns(payload, widget.id).pipe(
        map(() => paymentTableColumnActions.reorderColumnsComplete({ widget }))
      );
    })
  ));

  resizeColumns$Effect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableColumnActions.resizeColumns),
    switchMap(({ payload, widget }) => {
        return this.paymentsToYouHttpService.resizeColumns(payload, widget.id).pipe(
            map(() => paymentTableColumnActions.resizeColumnsComplete({ widget }))
      );
    })
  ));
}

